import { createModel } from "@rematch/core"
import { Maybe } from "fgr-lib-business-logic/lib/common/types"

export enum DialogType {
    LOGIN = "LOGIN_DIALOG",
    ORDER_CHECKOUT = "ORDER_CHECKOUT_DIALOG",
    PRODUCT_DETAIL = "PRODUCT_DETAIL_DIALOG",
    ORDER_PLACED = "ORDER_PLACED_DIALOG",
    TERMS_OF_SERVICE = "TERMS_OF_SERVICE_DIALOG",
    PRIVACY_POLICY = "PRIVACY_POLICY_DIALOG",
    PRODUCTS_UNAVAILABLE = "PRODUCTS_UNAVAILABLE_DIALOG",
    SCHEDULE_ORDER = "SCHEDULE_ORDER_DIALOG",
    LOGOUT = "LOGOUT_DIALOG",
    BUSINESS_CLOSED_ERROR_DIALOG = "BUSINESS_CLOSED_ERROR_DIALOG",
}

export type DialogsState = {
    openedDialog: Maybe<DialogType>
    dialogsData: Record<string, Record<string, any>>
}

const defaultState = {
    openedDialog: null,
    dialogsData: {},
}

export const dialogsModel = createModel({
    state: defaultState,
    reducers: {
        openDialog: (state: DialogsState, payload: { identifier: DialogType; data?: any }) => ({
            ...state,
            openedDialog: payload.identifier,
            dialogsData: {
                ...state.dialogsData,
                [payload.identifier]: payload.data,
            },
        }),
        closeDialog: (state: DialogsState, payload: { identifier: DialogType }) => {
            if (payload.identifier === state.openedDialog) {
                return {
                    ...state,
                    openedDialog: null,
                    dialogsData: {
                        ...state.dialogsData,
                        [payload.identifier]: null,
                    },
                }
            }
            return state
        },
        closeAllDialogs: (state: DialogsState) => {
            return {
                ...state,
                openedDialog: null,
                dialogsData: {},
            }
        },
    },
})
